import { request } from '@/utils/request'
const WarningService = {
  state: {},

  mutations: {},

  actions: {
    GetWarningList({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/WF/v1/GetWarningList', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetPorpertyList({ commit }) {
      return new Promise((resolve, reject) => {
        request.get('/api/equipment/v1/GetPorpertyList_ConfigurableRules').then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetWarningRulesList_By_PropertyIDs({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/equipment/v1/GetWarningRulesList_By_PropertyIDs', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetSelectedWarningRulesList_By_EquipmentIDs_PropertyIDs({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/equipment/v1/GetSelectedWarningRulesList_By_EquipmentIDs_PropertyIDs', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    SetEquipmentWarningRules({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/equipment/v1/SetEquipmentWarningRules', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    DelEquipmentWarningRules({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/equipment/v1/DelEquipmentWarningRules', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 告警大类
    getWarningClassTreeGridJson({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/Maintenance/WarnGroup/GetTreeGridJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 告警小类
    GetAllWarnWRC({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/Maintenance/WarnWarningRulesClass/GetAllWarnWRC', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 解决方案
    GetSelectJson({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/SystemManage/ItemsData/GetSelectJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 保存
    SaveWarningRule({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('/Maintenance/WarnWarningRules/SubmitForm', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除
    DeleteWarningRule({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('/Maintenance/WarnWarningRules/DeleteForm', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 更新读取状态
    UpdatereadStatus({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('api/WF/v1/UpdateWarningReadStatusByIds', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 忽略告警
    UpdateWarningStateByIds({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('api/WF/v1/UpdateWarningStateByIds', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetWarningDetailsEX({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('api/WF/v1/GetWarningDetailsEX', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
}
export default WarningService
